import { Text } from "@chakra-ui/react";
import { TouchableOpacity } from ".";
import { useTranslation } from "languages";
import { useNavigate } from "react-router-dom";
import { TouchableOpacityType } from "./TouchableOpacity";

const BackButton: React.FC<TouchableOpacityType> = ({
  mt = 10,
  mx = [4, 10],
  ...props
}) => {
  const { translation } = useTranslation();
  const navigation = useNavigate();
  return (
    <TouchableOpacity
      mx={mx}
      mt={mt}
      direction={"row"}
      align={"center"}
      alignSelf={"flex-start"}
      border={"1px solid var(--chakra-colors-primary-300)"}
      borderRadius={10}
      px={2}
      py={1}
      onClick={() => navigation(-1)}
      {...props}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="13"
        viewBox="0 0 10 16.667"
      >
        <path
          id="Path_578"
          data-name="Path 578"
          d="M8.512,18.667a1.493,1.493,0,0,1-1.055-.429L.433,11.363a1.447,1.447,0,0,1,0-2.064L7.458,2.424a1.525,1.525,0,0,1,2.109,0,1.447,1.447,0,0,1,0,2.064L3.6,10.331l5.97,5.843a1.447,1.447,0,0,1,0,2.064A1.428,1.428,0,0,1,8.512,18.667Z"
          transform="translate(0 -2)"
          fill="var(--chakra-colors-primary-300)"
        />
      </svg>
      <Text color={"primary.300"} fontWeight={"bold"}>
        {translation["back"]}
      </Text>
    </TouchableOpacity>
  );
};

export default BackButton;
